class URLParamHandler {
  constructor(currentURL) {
    this.url= new URL(currentURL);
    this.params = new URLSearchParams(this.url.search);
  }

  getParameter(paramName){
    let parameter = this.params.get(paramName);
    return parameter;
  }

  setParameter(paramName, value){
    this.params.set(paramName, value);
    history.pushState({}, null, '?'+this.params);
  }

}

export default URLParamHandler;
